export const USER_ACTIVITY_EVENT_TYPES = {
  1: "Logowanie do strony WWW",
  2: "Logowanie do stacji preselekcji",
  3: "Aktywność VMS",
  4: "Zapis wyszukiwania w archiwum",
  5: "Pobranie raportu",
  6: "Dodanie użytkownika",
  7: "Usunięcie użytkownika",
  8: "Nadanie uprawnień użytkownikowi",
  9: "Usunięcie uprawnień użytkownikowi",
};

export const USER_ACTIVITY_EVENT_KEY_BY_ID = {
  1: "login-www",
  2: "login-preselection",
  3: "vms-session",
  4: "archive-search-save",
  5: "report-download",
  6: "user-add",
  7: "user-delete",
  8: "permission-grant",
  9: "permission-revoke",
};
